import { PERMISSIONS } from '@base/shared';
import { useTranslation } from 'react-i18next';
import { PasswordChangeForm } from '../components/PasswordForm.tsx';
import { Panel } from '../components/ui.tsx';
import { localized } from '../i18n/index.ts';

const LABELS = new Map(PERMISSIONS.map((p) => [p.code as string, p.label]));

/** Aba Segurança de Minha conta (ADR 0139): a troca de senha e o que a pessoa pode fazer. */
export function SecurityTab({ permissions }: { permissions: readonly string[] }) {
  const { t } = useTranslation();
  return (
    <>
      <Panel title={t('password.title')}>
        <p className="mb-4 text-sm text-muted">{t('password.hint')}</p>
        <PasswordChangeForm />
      </Panel>
      <Panel title={t('account.access')}>
        <p className="mb-3 text-sm text-muted">{t('account.accessHint')}</p>
        {permissions.length === 0 ? (
          <p className="text-sm text-muted">{t('account.accessEmpty')}</p>
        ) : (
          <ul className="flex flex-col gap-1 text-sm">
            {permissions.map((p) => (
              <li key={p}>{localized(LABELS.get(p)) || p}</li>
            ))}
          </ul>
        )}
      </Panel>
    </>
  );
}
